var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1 9.52804C18.29 9.52804 17.55 8.24804 18.45 6.67804C18.97 5.76804 18.66 4.60804 17.75 4.08804L16.02 3.09804C15.23 2.62804 14.21 2.90804 13.74 3.69804L13.63 3.88804C12.73 5.45804 11.25 5.45804 10.34 3.88804L10.23 3.69804C9.78 2.90804 8.76 2.62804 7.97 3.09804L6.24 4.08804C5.33 4.60804 5.02 5.77804 5.54 6.68804C6.45 8.24804 5.71 9.52804 3.9 9.52804C2.86 9.52804 2 10.378 2 11.428V13.188C2 14.228 2.85 15.088 3.9 15.088C5.71 15.088 6.45 16.368 5.54 17.938C5.02 18.848 5.33 20.008 6.24 20.528L7.97 21.518C8.76 21.988 9.78 21.708 10.25 20.918L10.36 20.728C11.26 19.158 12.74 19.158 13.65 20.728L13.76 20.918C14.23 21.708 15.25 21.988 16.04 21.518L17.77 20.528C18.68 20.008 18.99 18.838 18.47 17.938C17.56 16.368 18.3 15.088 20.11 15.088C21.15 15.088 22.01 14.238 22.01 13.188V11.428C22 10.388 21.15 9.52804 20.1 9.52804ZM12 15.558C10.21 15.558 8.75 14.098 8.75 12.308C8.75 10.518 10.21 9.05804 12 9.05804C13.79 9.05804 15.25 10.518 15.25 12.308C15.25 14.098 13.79 15.558 12 15.558Z",
    fill: "#464650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.f3cfb83a3a413ca5835442eec29b01a5.svg";
export { ForwardRef as ReactComponent };